module.exports = "/_next/static/images/c5c7a680e11e1cc477d2229a8c5705f5-nubanker-bizarch@1x.jpg";